import Container from "./Container";
import Texts from "../utilis/defaults/Text"
import Logo from "../images/logo.png"
import React, {useContext, useState} from "react";
import AuthContext from "../utilis/contexts/AuthContext";
import {Avatar, Button, Divider, Drawer, Menu, notification} from "antd";
import AppContext from "../utilis/contexts/AppContext";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {
    AimOutlined,
    AppstoreOutlined,
    BarcodeOutlined, DatabaseOutlined, DollarCircleOutlined,
    HomeOutlined, MonitorOutlined,
    PlusOutlined,
    ProfileOutlined,
    SettingOutlined, ShoppingCartOutlined, ShoppingOutlined
} from "@ant-design/icons";
import ServiceCode from "../utilis/enums/ServiceCode";
import Api from "../utilis/api/service";
import Urls from "../utilis/api/Urls";
import {AxiosError, AxiosResponse} from "axios";
import LocalStorage from "../utilis/tools/LocalStorage";
import branchInfo from "../utilis/models/branchInfo";
import serviceCode from "../utilis/enums/ServiceCode";
import AsredadeLogo from "../images/asredadehLogo.png";

const Header = () => {
    const authContext = useContext(AuthContext)
    const [openDrawer, setOpenDrawer] = useState(false);

    const showDrawer = () => {
        setOpenDrawer(true);
    };
    const location = useLocation()

    React.useEffect(() => {
        setOpenDrawer(false)
    }, [location])
    const onClose = () => {
        setOpenDrawer(false);
    };
    const appContext = useContext(AppContext)
    const navigate = useNavigate();
    const handleNavigate = (path: string) => {

        setOpenDrawer(false)

        const noDeptAffect = [serviceCode.TemporaryDisconnectAndConnectBranch,serviceCode.SaleTankerWater, serviceCode.WaterBranchAssignment, ServiceCode.BillingReview, ServiceCode.MidTermBill, ServiceCode.DeclareMeterConsumption]
        /*const hasDept=noDeptAffect.includes('1-02' as ServiceCode);*/
        let isContain = false;
        Object.values(noDeptAffect).forEach((item: ServiceCode) => {
            if (item.toString() === path) {
                isContain = true;
            }
        })
        if (!isContain && authContext.currentBranchInfo.has_debt) {
            notification['error']({
                message: '',
                description: authContext.currentBranchInfo.debt_message,
                duration: 120
            });


        } else {
            navigate(`/panel/${path}`, {
                state: {
                    hasRefresh: true,
                }
            })
        }

    }
    const handleBranchInfo = (fileNum: string, redirect: boolean) => {

        appContext.handleLoading(true)
        Api.post(Urls.getBranchInfo, {
            Cellphone: authContext.user.cellphone,
            FileNumber: fileNum
        }, {
            headers: {
                "Authorization": authContext.Token.tokenType + " " + authContext.Token.accessToken
            }
        }).then((response: AxiosResponse) => {

            const {data} = response;
            const {Data, Status} = data;
            const {branches, branch_info} = Data;
            if (Status === 0) {
                LocalStorage.setFileNumber(fileNum);
                authContext.handleCurrentFileNumber(fileNum)
                authContext.handleCurrentBranchInfo(Object.keys(branch_info).length === 0 ? new branchInfo() : branch_info)
                authContext.handleBranches(branches)
                authContext.handleCurrentFileNumber(fileNum)
                navigate('/panel')
            }

        }).catch((e: AxiosError) => {

        }).finally(() => {
            appContext.handleLoading(false)
        })

    }

    return <div className="py-3 my-header shadow w-full">

        {authContext.authenticated &&
            <Drawer title={Texts.appName} placement="right" onClose={onClose} open={openDrawer}>
                <div className="w-full  flex justify-center p-3 items-center flex-col ">
                    <Avatar className="mb-3" size="large">{authContext.user.name.charAt(0)}</Avatar>
                    <div className="flex justify-center mt-2 items-center flex-col">
                        <span className="font-12">{authContext.user.name}</span>
                        <span className="font-12">{authContext.user.cellphone}</span>
                        <Button danger type="primary" onClick={() => authContext.logout()} className="mt-2 px-5 py-2"
                                size="small">خروج</Button>
                    </div>

                    <Divider orientation="center" type="horizontal" orientationMargin={1}/>
                    <Menu
                        mode="inline"
                        defaultSelectedKeys={['1']}
                        defaultOpenKeys={['sub1']}
                        style={{borderRight: 0}}

                    >
                        <Menu.Item key={"home"} onClick={() => setOpenDrawer(false)}>
                            <Link to={'/panel/'}>
                                <HomeOutlined/>
                                <span>صفحه اصلی</span>
                            </Link>
                        </Menu.Item>
                        <Menu.SubMenu
                            key={"sub-1"}
                            title={
                                <>
                                    <BarcodeOutlined/>
                                    <span>اشتراک ها</span>
                                </>
                            }

                        >
                            <Menu.Item key={"new-branch"} onClick={() => {
                                setOpenDrawer(false)
                                authContext.handleAddBranchModal(true)
                            }}>
                                <PlusOutlined/>
                                <span>افزودن اشتراک</span>
                            </Menu.Item>
                            {
                                authContext.branches.map((branch: any, index) => <Menu.Item
                                    className={branch.file_number === authContext.currentFileNumber ? 'ant-menu-item-selected' : ''}
                                    onClick={() => {
                                        setOpenDrawer(false)
                                        handleBranchInfo(branch.file_number, true)
                                    }} key={index + "new-branch"}>

                                    <span>{branch.file_number}</span>
                                </Menu.Item>)
                            }

                        </Menu.SubMenu>
                        <Menu.SubMenu
                            key={"sub-2-list"}
                            title={
                                <>
                                    <BarcodeOutlined/>
                                    <span> خدمات ۲۴ گانه</span>
                                </>
                            }

                        >

                            {authContext.currentFileNumber && authContext.currentFileNumber !== "" && <>
                                <Menu.Item key={Texts.ReplyToInquiry}
                                           onClick={() => handleNavigate(ServiceCode.ReplyToInquiry)}>
                                    <span>{Texts.ReplyToInquiry}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.BillingReview}
                                           onClick={() => handleNavigate(ServiceCode.BillingReview)}>
                                    <span>{Texts.BillingReview}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.ChangeAccountType}
                                           onClick={() => handleNavigate(ServiceCode.ChangeAccountType)}>
                                    <span>{Texts.ChangeAccountType}</span>
                                </Menu.Item>

                                <Menu.Item key={Texts.ChangeBranchDiameter}
                                           onClick={() => handleNavigate(ServiceCode.ChangeBranchDiameter)}>
                                    <span>{Texts.ChangeBranchDiameter}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.ChangeSpecifications}
                                           onClick={() => handleNavigate(ServiceCode.ChangeSpecifications)}>
                                    <span>{Texts.ChangeSpecifications}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.ChangeCapacityContractualBranching}
                                           onClick={() => handleNavigate(ServiceCode.ChangeCapacityContractualBranching)}>
                                    <span>{Texts.ChangeCapacityContractualBranching}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.ChangeUnit}
                                           onClick={() => handleNavigate(ServiceCode.ChangeUnit)}>
                                    <span>{Texts.ChangeUnit}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.MeterTest}
                                           onClick={() => handleNavigate(ServiceCode.MeterTest)}>
                                    <span>{Texts.MeterTest}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.MeterChange}
                                           onClick={() => handleNavigate(ServiceCode.MeterChange)}>
                                    <span>{Texts.MeterChange}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.DeclareMeterConsumption}
                                           onClick={() => handleNavigate(ServiceCode.DeclareMeterConsumption)}>
                                    <span>{Texts.DeclareMeterConsumption}</span>
                                </Menu.Item>

                                <Menu.Item key={Texts.CollectOrMergeBranch}
                                           onClick={() => handleNavigate(ServiceCode.CollectOrMergeBranch)}>
                                    <span>{Texts.CollectOrMergeBranch}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.TemporaryDisconnectAndConnectBranch}
                                           onClick={() => handleNavigate(ServiceCode.TemporaryDisconnectAndConnectBranch)}>
                                    <span>{Texts.TemporaryDisconnectAndConnectBranch}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.MidTermBill}
                                           onClick={() => handleNavigate(ServiceCode.MidTermBill)}>
                                    <span>{Texts.MidTermBill}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.InstallAdditionalSiphon}
                                           onClick={() => handleNavigate(ServiceCode.InstallAdditionalSiphon)}>
                                    <span>{Texts.InstallAdditionalSiphon}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.MoveMeasuringDevices}
                                           onClick={() => handleNavigate(ServiceCode.MoveMeasuringDevices)}>
                                    <span>{Texts.MoveMeasuringDevices}</span>
                                </Menu.Item>
                                <Menu.Item key={Texts.WasteWaterBranchAssignment}
                                           onClick={() => handleNavigate(ServiceCode.WasteWaterBranchAssignment)}>
                                    <span>{Texts.WasteWaterBranchAssignment}</span>
                                </Menu.Item>

                                <Menu.Item key={Texts.MeterSeparation}
                                           onClick={() => handleNavigate(ServiceCode.MeterSeparation)}>
                                    <span>{Texts.MeterSeparation}</span>
                                </Menu.Item>


                            </>}
                            <Menu.Item key={Texts.SaleTankerWater}
                                       onClick={() => handleNavigate(ServiceCode.SaleTankerWater)}>
                                <span>{Texts.SaleTankerWater}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.WaterBranchAssignment}
                                       onClick={() => handleNavigate(ServiceCode.WaterBranchAssignment)}>
                                <span>{Texts.WaterBranchAssignment}</span>
                            </Menu.Item>
                            <Menu.Item key={Texts.WaterBranchAssignment}
                                       onClick={() => {
                                           window.open('http://195.181.42.3:9084','_blank')
                                       }
                                       }>
                                <span>{Texts.Accidents}</span>
                            </Menu.Item>


                        </Menu.SubMenu>

                        <Menu.Item onClick={() => {
                            setOpenDrawer(false)
                        }
                        } key={"payments-list"}>
                            <Link to={'/panel/bills'}>
                                <ProfileOutlined/>
                                <span>لیست قبض ها</span>
                            </Link>
                        </Menu.Item>

                        {authContext.currentFileNumber && authContext.currentFileNumber !== "" &&
                            <Menu.Item key={"payments"}>
                                <Link to={'/panel/paymentHistory'}>
                                    <ShoppingOutlined/>
                                    <span>لیست پرداخت ها</span>
                                </Link>
                            </Menu.Item>}
                        {
                            authContext.authenticated && <>
                                <Menu.Item onClick={() => {
                                    setOpenDrawer(false)
                                }
                                } key={"manageFiles"}>
                                    <Link to={'/panel/manageFiles'}>
                                        <DatabaseOutlined/>
                                        <span>مدیریت پرونده ها</span>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item onClick={() => {
                                    setOpenDrawer(false)
                                }
                                } key={"myRequests"}>
                                    <Link to={'/panel/myRequests'}>
                                        <AimOutlined/>
                                        <span>درخواست های من</span>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key={"findWorkFlow"}>
                                    <Link to={'/panel/findWorkFlow'}>
                                        <MonitorOutlined/>
                                        <span>پیگیری درخواست</span>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key={"myTransactions"}>
                                    <Link to={'/panel/MyTransactions'}>
                                        <DollarCircleOutlined/>
                                        <span>تراکنش های من</span>
                                    </Link>
                                </Menu.Item>
                            </>
                        }

                    </Menu>

                    <div className="">
                        <a className="border-t flex justify-center items-center  p-3" target="_blank"
                           href="https://asredade.com">
                            <img className="w-[25px] pl-2 h-auto" src={AsredadeLogo} alt=""/>
                            <small className="text-gray-600">تهیه و توسعه توسط شرکت <span
                                className="text-red-500">عصرداده</span> </small>
                        </a>
                    </div>
                </div>
            </Drawer>}
        <Container fluid={true} className="justify-between flex items-center">
            <div className="block lg:hidden">{authContext.authenticated && <Avatar onClick={showDrawer}
                                                                                   className="cursor-pointer block lg:hidden ">{authContext.user.name.charAt(0)}</Avatar>}</div>
            <div className="flex justify-start items-center ">
                <Link to={'/panel/'} className="flex justify-start items-center">
                    <img className="w-[35px] h-auto ml-2 " src={Logo} alt=""/><strong
                    className="hidden  md:block">{Texts.appName}</strong>
                </Link>

            </div>
            <a target="_blank" className="p-1 text-sm bg-primary bg-opacity-10 text-primary rounded" href="https://www.abfa-mazandaran.ir/page-English/en/0/form/pId1880">EN</a>

        </Container></div>
}
export default Header;